// extracted by mini-css-extract-plugin
module.exports = {"Post":"Post_Post__3tPsf","Header":"Post_Header__18TdI","Content":"Post_Content__2qaRd","PostTitle":"Post_PostTitle__1_9vf","PostContent":"Post_PostContent__2JFQs"};